import { Board, User } from 'types';
import boardStatus from 'constants/boardStatus';
import { store } from 'redux/store';

const forbiddenStatus = [boardStatus.PENDING.value, boardStatus.CANCELED.value];

const currentUserRepresentants = (): string[] =>
  store.getState().user?.partnerRepresentants || [];

export const isBoardVisibleAtList = (
  board: Board,
  memberId: string,
  user: User
) => {
  const isStatusAllowed = !forbiddenStatus.includes(board.status);

  const isMemberParticipant = board.participants?.some(
    (participant) => participant.member === memberId
  );

  const isMemberRepresentant = board?.delegationRepresentants?.some(
    (representant) => currentUserRepresentants().includes(representant)
  );

  const isMemberPartnerFromUser = board?.participants?.some((participant) =>
    user?.partners?.includes(participant.member)
  );

  return (
    isStatusAllowed &&
    (isMemberParticipant || isMemberRepresentant || isMemberPartnerFromUser)
  );
};
